import React from 'react'
import img1 from "../../assets/OnboardingImages/7.png"
import img2 from "../../assets/OnboardingImages/8.png"
import img3 from "../../assets/OnboardingImages/10.png"
import img4 from "../../assets/OnboardingImages/11-Set up.png"
import img5 from "../../assets/OnboardingImages/12.1.png"
import img6 from "../../assets/OnboardingImages/13.1.png"


const Introduction = () => {
  return (
    <div className='h-full bg-[#f3f4f6] pr-48'>
    <div className="cursor-default">
         {/* Set Signals Section */}
      <h2 className="text-2xl font-semibold mt-6 mb-2">Set Signals</h2>
      <p className="mt-3 text-lg">
        Next step is to set up signals. You can start by going to the <strong>Intel</strong> page. Click on the <strong>Setting</strong> icon on the side panel to begin.
      </p>

      <p className="mt-3 text-lg">
        Here you have two options: <strong>Playground</strong> and <strong>Setup</strong>.
      </p>

      {/* Playground Section */}
      <h3 className="text-xl font-semibold mt-4 mb-2">Playground</h3>
      <p className="mt-3 text-lg">
        If you want to check before moving to the final setup, you can start with <strong>Playground</strong>.
      </p>
      <img className='mt-6 mb-16 border-solid border-2 border-black' src={img1}/>
      <p className="mt-3 text-lg">
      You can choose relevant <strong>Triggers, Industry, About the Company, and Products/Offerings</strong>.
      </p>
      <img className='mt-6 mb-16 border-solid border-2 border-black' src={img2}/>
      <p className="mt-3 text-lg">
        Once you enter all the sections and click on the <strong>Test</strong> button, Zoi will analyze the internet and fetch the relevant report, highlighting why it is relevant, talking points, and offerings.
      </p>
      <img className='mt-6 mb-16 border-solid border-2 border-black' src={img3}/>
      <p className="mt-3 text-lg">Once you are satisfied with the result, you can move to the setup section to start generating leads.</p>

      {/* Setup Section */}
      <h3 className="text-xl font-semibold mt-4 mb-2">Setup</h3>
      <p className="mt-3 text-lg">
        Go to the <strong>Setup</strong> section. Here you can set up fields like Triggers, About the Client, Products/Offerings, Industries, and Companies you want to follow.
      </p>
      <img className='mt-6 mb-16 border-solid border-2 border-black' src={img4}/>
      <p className="mt-3 text-lg">
        Once all the fields are done, click on the <strong>Save</strong> button at the top right.
      </p>
      <img className='mt-6 mb-16 border-solid border-2 border-black' src={img5}/>
      <p className="mt-3 text-lg">
      Once the AI finishes analyzing and searching the internet, you will see all the updates based on the industries, triggers, and companies you chose.
      </p>
      <img className='mt-6 mb-16 border-solid border-2 border-black' src={img6}/>  
        </div>
        </div>
  )
}

export default Introduction